import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import isTomorrowPlugin from 'dayjs/plugin/isTomorrow'
import localeData from 'dayjs/plugin/localeData'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import updateLocale from 'dayjs/plugin/updateLocale'
import weekday from 'dayjs/plugin/weekday'

dayjs.extend(localeData)
dayjs.extend(updateLocale)
dayjs.extend(weekday)
dayjs.extend(customParseFormat)
dayjs.extend(localizedFormat)
dayjs.extend(isTomorrowPlugin)

/** @deprecated use time from utils */
export function replaceFormat(date: string, fromFormat: string | undefined, toFormat: string | undefined): string {
  return dayjs(date, fromFormat, true).format(toFormat)
}

/** @deprecated use time from utils */
export function toISO(date: string, format?: string): string {
  return replaceFormat(date, format, undefined)
}
